import PropTypes from 'prop-types';
import React from 'react';

import { Color, colorList } from '../../../typings/design-tokens';
import { IComponent } from '../../../typings/generic-component';
import { IClassNames, makeClassNames } from '../../../utils/styles';

import './dot.scss';

export interface IDot extends IComponent {
  isBlinking?: boolean;
}

const classNames = (color: Color, isBlinking = false): IClassNames =>
  makeClassNames({
    dot: ['dot', `dot--bg-color-${color}`, isBlinking && `dot--blinking`],
    wrapper: 'dot--wrapper',
  });

const Dot: React.FC<IDot> = ({ color = 'red-light', isBlinking = false }) => {
  const cn = classNames(color, isBlinking);

  return (
    <div className={cn.wrapper}>
      <span className={cn.dot} />
    </div>
  );
};

Dot.propTypes = {
  color: PropTypes.oneOf(colorList),
  isBlinking: PropTypes.bool,
};

export default Dot;
